<template>
	<div>
		<modalconfirm ref="modalReceiptTDO" @action="proccessTDO"/>
		<modalconfirm noconfirm ref="modalInfoTDO"/>
		<div class="text-h5">Penerimaan Transfer Stok</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-form>
					<v-row>
						<v-col cols="12" md="4">
							<v-autocomplete item-value="tdo_code" @change="getDetail(tdo_code)" hide-details v-model="tdo_code" :items="TDOforreceive" label="Kode Pengiriman" outlined dense :error-messages="responseError.tdo_id" @focus="() => responseError.tdo_id = ''" no-data-text="Belum ada data tersedia">
								<template v-slot:item = {item}>
									{{item.tdo_code}} - {{item.warehouse_name}}
								</template>
								<template v-slot:selection = {item}>
									{{item.tdo_code}}
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="12">
							<v-data-table disable-pagination :headers="headers" :items="productToReceive" hide-default-footer no-data-text="Tidak ada data yang sesuai">
								<template v-slot:item.product_name="{ item }">
									<div class="pt-2">{{ item.tdo_detail_product_name }}</div>
								</template>
								<template v-slot:item.product_code="{ item }">
									<div class="pt-2">{{ item.tdo_detail_product_code }}</div>
								</template>
								<template v-slot:item.quantity_sent="{ item }">
									<div class="pt-2">{{ item.tdo_detail_quantity_sent | toNumber }}</div>
								</template>
								<template v-slot:item.quantity_received="{ item }">
									<v-currency-field v-model.lazy="item.quantity" :rules="[inputrules.required, inputrules.notnull]" outlined dense hide-details="auto" background-color="white" class="py-3" :disabled="item.product_is_serial_digital == 'true'"></v-currency-field>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-4 pb-4">
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" :disabled="!tdo_code" depressed class="text-capitalize" @click="receipt">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			tdo_code: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: true},
			{ text: 'Kode Produk', value: 'product_code', sortable: false},
			{ text: 'Jumlah Dikirim', value: 'quantity_sent'},
			{ text: 'Jumlah Diterima', value: 'quantity_received', width: '18%'},
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('tdo', ['detailTDO', 'response', 'responseError', 'TDOforreceive']),

		productToReceive() {
			let product = []
			if (this.detailTDO.tdo_detail) {
				product = this.detailTDO.tdo_detail.map((el) => {
					el.quantity = el.tdo_detail_quantity_sent
					return el
				})
			}
			return product
		}
	},
	methods: {
		...mapActions('tdo', ['getDetailTDO', 'approvePO', 'receiveTDO', 'getOptionTDOforReceive']),
		...mapMutations('tdo', ['setDetailTDO', 'clearDataTDO', 'saveResponse']),
		...mapMutations(['setOverlay']),

		getDetail(code) {
			if (code) {
				this.getDetailTDO(code)
			} else {
				this.setDetailTDO({})
			}
		},
		receipt(){
			let msg = "Yakin akan memproses pengiriman ini?"
			this.$refs.modalReceiptTDO.setMessage(msg)
			this.$refs.modalReceiptTDO.showConfirm()
		},
		async proccessTDO() {
			await this.setOverlay(true)
			await this.$refs.modalReceiptTDO.hideConfirm()
			let product = await this.productToReceive.map( (el) => {
				return {
					product_id: el.tdo_detail_product_id,
					quantity: el.quantity,
					product_name: el.tdo_detail_product_name
				}
			})
			let params = await {
				tdo_id: this.detailTDO.tdo_id,
				product: product
			}
			await this.receiveTDO(params).then(() => {
				if (this.response.data.completed) {
					this.$refs.modalInfoTDO.showConfirm()
					this.$refs.modalInfoTDO.setMessage('Barang yang diterima sudah sesuai pesanan. Status Transfer Stok sekarang telah menjadi Selesai')
					this.$refs.modalInfoTDO.setCloseText("OK")
				}
				if (this.response.code == 200.) {
					this.saveResponse({})
					this.tdo_code = ''
					this.setDetailTDO('')
					this.getOptionTDOforReceive()
				}
			})
			await this.setOverlay(false)
		}
	},
	created() {
		this.getOptionTDOforReceive()
		this.$store.dispatch('setPageTitle', `Penerimaan Transfer Stok`);
		if (this.$route.params.code) {
			this.tdo_code = this.$route.params.code
			this.getDetailTDO(this.tdo_code)
		}
	},
	beforeDestroy() {
		this.clearDataTDO()
	},
	watch: {
	}
}
</script>